import {
  FETCH_USERTEAM_DATA,
  FETCH_MEMBERTEAM_DATA,
  FETCH_USERTEAM_DATA_ERROR,
  FETCH_USERTEAM_DATA_LOADING,
  FETCH_USERTEAM_DATA_COMPLETED
} from "../constants";
import { filterSetValue } from "./FilterActions";
import gql from "graphql-tag";
import client from "../apolloClient";

export function userTeamDataFetchData(fetchQuery, limit = 30, page = 1) {
  return (dispatch, getState) => {
    dispatch(userTeamDataIsLoading(true));
    dispatch(userTeamDataIsCompleted(false));

    let query;
    if (fetchQuery) {
      query = fetchQuery;
    } else {
      query = gql`
      {
        simcaa_t_userxteam(where: {iduser: {_eq: ${getState().user.id}}}) {
          role_id
          user_permissions
          status
          team {
            id
            name
            status
          }
          user {
            id
            user
          }
          role {
            role_desc
          }
        }
      }
      `;
    }

    client
      .query({ query })
      .then(data => {
        dispatch(userTeamDataIsLoading(false));
        if (data.networkStatus !== 7) {
          dispatch(userTeamDataHasErrored(true));
        } else {
          let user_teams = data.data.simcaa_t_userxteam.map(item => ({
            user_id: item.user.id,
            name: item.user.user,
            team_id: item.team.id,
            team_name: item.team.name,
            status: item.status,
            status_team: item.team.status,
            ...item
          }));
          dispatch(userTeamDataHasErrored(false));
          dispatch(userTeamDataFetchDataSuccess(user_teams));

          // Set default team
          dispatch(filterSetValue(user_teams[0].team_id));

          // Set the finish of the query for InitProgress
          dispatch(userTeamDataIsCompleted(true));
        }
      })
      .catch(error => {
        dispatch(userTeamDataIsLoading(false));
        dispatch(userTeamDataHasErrored(true));
      });
  };
}

// TODO: vedere se serve ancora
export function membersTeamDataFetchData(
  fetchQuery,
  id = null,
  limit = 1000,
  page = 1
) {
  return (dispatch, getState) => {
    // dispatch(userTeamDataIsLoading(true));
    // let query,
    //   team_id = id ? id : getState().filterValue;

    // if (fetchQuery) {
    //   query = fetchQuery;
    // } else {
    //   query = gql`
    //         query allMembersCurrentTeam {
    //             user_teams (team_id: ${team_id}, limit: ${limit}, page: ${page}){
    //                 data {
    //                   user_id
    //                   username
    //                   team_id
    //                 }
    //             }
    //         }
    //         `;
    // }

    // client.query({ query })
    //   .then(data => {
    //     dispatch(userTeamDataIsLoading(false));
    //     if (data.data.user_teams.error) {
    //       dispatch(userTeamDataHasErrored(true));
    //     } else {
    //       dispatch(userTeamDataHasErrored(false));
    //       dispatch(membersTeamDataFetchDataSuccess(data.data.user_teams.data));
    //     }
    //   })
    //   .catch(error => {
    //     dispatch(userTeamDataIsLoading(false));
    //     dispatch(userTeamDataHasErrored(true));
    //   });
  };
}

export function userTeamDataHasErrored(bool) {
  return {
    type: FETCH_USERTEAM_DATA_ERROR,
    hasErrored: bool
  };
}

export function userTeamDataIsLoading(bool) {
  return {
    type: FETCH_USERTEAM_DATA_LOADING,
    isLoading: bool
  };
}

export function userTeamDataIsCompleted(isCompleted) {
  return {
    type: FETCH_USERTEAM_DATA_COMPLETED,
    isCompleted
  };
}

export function userTeamDataFetchDataSuccess(team) {
  return {
    type: FETCH_USERTEAM_DATA,
    team
  };
}

export function membersTeamDataFetchDataSuccess(members) {
  return {
    type: FETCH_MEMBERTEAM_DATA,
    members
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/UserTeamFetchActions.js